<template>
    <u-text-field-outlined-pill v-model="modelValue" v-bind="$attrs" @input="$emit('input', modelValue)" class="v-text-field--label-inner">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-text-field-outlined-pill>
</template>

<script>
import UTextFieldOutlinedPill from "@/components/publish/styles/forms/u-text-field-outlined-pill.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        UTextFieldOutlinedPill,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
